module.exports = __webpack_public_path__ + "img/logo.62783da1.svg";